import { MonitorDetailsSubscriberSection } from "../MonitorDetailsSubscriberSection";
import { getDefaultNotificationLevel } from "@avenueops/frontend-shared";
import { ClientWorkflow, SetEscalationPolicyInput } from "@avenueops/shared-types";
import { Button, Card } from "@avenueops/web-components";
import { zodResolver } from "@hookform/resolvers/zod";
import { WorkflowTriggerType } from "@prisma/client";
import { AddSubscriberSection } from "components/monitors/editFormReboot/AddSubscriberSection";
import { EscalationPolicySection } from "components/monitors/editFormReboot/EscalationPolicySection";
import { getDefaultCreateWorkflowInput } from "components/monitors/editFormReboot/MonitorEditForm";
import { useOrganization } from "context/OrganizationContext";
import { QueryRunProvider } from "context/QueryRunContext";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { trpc2 } from "utils/trpc";

export function getDefaultEscalationPolicyInput(workflow: ClientWorkflow): SetEscalationPolicyInput {
  return {
    workflowId: workflow.id ?? "",
    maximumEscalationPolicyAttempts: workflow.maximumEscalationPolicyAttempts ?? undefined,
    repeatEscalationPolicyAfterTimePeriodQuantity: workflow.repeatEscalationPolicyAfterTimePeriodQuantity ?? undefined,
    repeatEscalationPolicyAfterTimePeriod: workflow.repeatEscalationPolicyAfterTimePeriod ?? undefined,
    repeatEscalationPolicy: workflow.maximumEscalationPolicyAttempts !== undefined && workflow.maximumEscalationPolicyAttempts !== null,
    notificationLevels:
      workflow.notificationLevels && workflow.notificationLevels.length > 0 ? workflow.notificationLevels : [getDefaultNotificationLevel({ isEmpty: true })],
  };
}

interface Props {
  workflow: ClientWorkflow & { id: string };
}

export const MonitorEscalationPolicyContent = ({ workflow, readOnly }: { workflow: ClientWorkflow & { id: string }; readOnly: boolean }) => {
  return readOnly ? (
    <>
      <div className="flex flex-col text-sm text-gray-950">
        {/* Recipients */}
        <div>
          <MonitorDetailsSubscriberSection workflow={workflow} />
        </div>
        {/* Escalation Policy */}
        {workflow.maximumEscalationPolicyAttempts &&
        workflow.repeatEscalationPolicyAfterTimePeriod &&
        workflow.repeatEscalationPolicyAfterTimePeriodQuantity ? (
          <div className="flex flex-col md:flex-row py-3 text-gray-950 items-start">
            {`If signal is not resolved, repeat this escalation policy ${workflow.maximumEscalationPolicyAttempts} time${
              workflow.maximumEscalationPolicyAttempts === 1 ? "" : "s"
            } every ${workflow.repeatEscalationPolicyAfterTimePeriodQuantity} ${workflow.repeatEscalationPolicyAfterTimePeriod?.toLowerCase()}.`}
          </div>
        ) : null}
      </div>
    </>
  ) : (
    <QueryRunProvider workflowId={workflow.id}>
      <AddSubscriberSection workflow={workflow} />
      <EscalationPolicySection />
    </QueryRunProvider>
  );
};
